export default __webpack_public_path__ + "static/Hero-Transcript-a50858a591ece33e915841d5644bcb39.pdf";